module.exports = __webpack_public_path__ + "static/media/enlight-logo.978ed228.png";